import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7OPCVMTimeSerieFilesSchema = z.object({
  date_equals: z.string().optional(),
  denomination_fonds_contains: z.string().optional(),
  error_message_contains: z.string().optional(),
});

export type FilterA7OPCVMTimeSerieFilesSchema = z.infer<
  typeof filterA7OPCVMTimeSerieFilesSchema
>;

export function FilterA7OPCVMTimeSerieFiles({
  table_name,
}: {
  table_name: string;
}) {
  const { t, i18n } = useTranslation();
  const initialFields: Field[] = useMemo(
    () => [
      {
        name: "date_equals",
        label: t("a7_opcvm_time_serie_files.columns.date", {
          ns: "tables",
          defaultValue: "Date",
        }),
        type: "autocomplete",
        options: [],
      },
      {
        name: "denomination_fonds_contains",
        label: t("a7_opcvm_time_serie_files.columns.a7_opcvm_strategy_name", {
          ns: "tables",
          defaultValue: "Fonds",
        }),
        type: "input",
      },
      {
        name: "error_message_contains",
        label: t("a7_opcvm_time_serie_files.columns.error_message", {
          ns: "tables",
          defaultValue: "Message d'erreur",
        }),
        type: "input",
      },
    ],
    [i18n.language, t],
  );
  const { fields } = useDateOptions("a7", table_name, initialFields);

  return (
    <FilterTable
      schema={filterA7OPCVMTimeSerieFilesSchema}
      tableName="a7_opcvm_time_serie_files"
      fields={fields}
      client="a7"
      customBuildPath={() => `a7-opcvm/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
